import React from "react";
import { Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, Switch } from "@mui/material";
import { Controller } from "react-hook-form";
import { SubmittableForm } from "components/form/SubmittableForm";

export type ProtectUserGrantsArguments = {
  isProtected: boolean;
};

type ProtectUserGrantsDialogProps = {
  currentValue: boolean;
  open: boolean;
  handleClose: () => void;
  submitChange: (args: ProtectUserGrantsArguments) => Promise<void>;
};

export function ProtectUserGrantsDialog(props: ProtectUserGrantsDialogProps) {
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <DialogTitle>Protect User Access</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} rowSpacing={2}>
          <Grid size={12}>
            <i>By default, all users with write permission can change user access for this cloud subscription.</i>
          </Grid>
          <Grid size={12}>
            <SubmittableForm submitAction={props.submitChange}>
              {(formController) => {
                const { register, control } = formController;

                return (
                  <Grid container spacing={3}>
                    <Grid
                      size={{
                        sm: 12,
                      }}
                    >
                      <Controller
                        name="isProtected"
                        control={control}
                        defaultValue={props.currentValue}
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Switch onChange={(e) => field.onChange(e.target.checked)} checked={field.value} />
                            }
                            label={"Restrict user grant changes to Admins only"}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                );
              }}
            </SubmittableForm>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
